import Actions from './actions';

const setLoginRedirectUrl = Actions.setLoginRedirectUrl;

export { setLoginRedirectUrl };
